import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInvoicing = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 1.125C2.8599 1.125 1.125 2.8599 1.125 5V11C1.125 13.1401 2.8599 14.875 5 14.875H11C13.1401 14.875 14.875 13.1401 14.875 11V5C14.875 2.8599 13.1401 1.125 11 1.125H5ZM11 2.125C12.5878 2.125 13.875 3.41218 13.875 5V11C13.875 12.5878 12.5878 13.875 11 13.875H5C3.41218 13.875 2.125 12.5878 2.125 11V5C2.125 3.41218 3.41218 2.125 5 2.125H11ZM8.58301 4.46387C8.38781 4.26866 8.07125 4.26879 7.87598 4.46387L4.69824 7.64062C4.5259 7.81318 4.50729 8.07991 4.63965 8.27441C4.65878 8.3043 4.68091 8.33326 4.70703 8.35938L7.88379 11.5371C8.07896 11.7319 8.39565 11.7319 8.59082 11.5371C8.78596 11.342 8.78573 11.0254 8.59082 10.8301L6.26953 8.50684C6.2873 8.50769 6.30514 8.51074 6.32324 8.51074H10.918C11.3289 8.51074 11.6618 8.2867 11.6621 8.01074C11.6621 7.7346 11.3291 7.51075 10.918 7.51074H6.32324C6.29413 7.51075 6.26554 7.51343 6.2373 7.51562L8.58301 5.1709C8.77795 4.97576 8.7778 4.6591 8.58301 4.46387Z",
		fill: "currentColor"
	})
});
export default SvgInvoicing;
